export default __webpack_public_path__ + "static/arcade-21562e1d4df3b50b785a3eb30e43f55d.gif";